import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import PendingProductInstanceTableView from './table';
import { classes } from './styles/provision-table';
import { Button } from 'reactstrap';

class PendingProductInstanceProvisionTableView extends React.Component {

  render() {
    const { t, disabled, items, onSelect, selected, emptyMessage, onProvision, onDecline } = this.props;
    return (
      <React.Fragment>
        <div className={classes.header}>
          <div />
          <h3>{t('provisionTable.header')}</h3>
          <div  className={classes.actions}>
            <Button
              color="primary"
              size="sm"
              disabled={disabled || !selected}
              onClick={onProvision}
            >
              {t('provisionTable.provisionAction')}
            </Button>
            <Button
              color="danger"
              size="sm"
              disabled={disabled || !selected}
              onClick={onDecline}
            >
              {t('provisionTable.declineAction')}
            </Button>
          </div>
        </div>
        <PendingProductInstanceTableView
          items={items}
          onSelect={onSelect}
          selected={selected}
          emptyMessage={emptyMessage}
          disabled={disabled}
        />
      </React.Fragment>
    );
  }

}

PendingProductInstanceProvisionTableView.propTypes = {
  ...PendingProductInstanceTableView.propTypes,
  disabled: PropTypes.bool,
  onProvision: PropTypes.func,
  onDecline: PropTypes.func
};

export default translate(['pending'])(PendingProductInstanceProvisionTableView);



// WEBPACK FOOTER //
// ./src/views/pending-product-instance/provision-table.js